import React, { useState, useEffect, useRef } from 'react'
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import { useApp } from "../../contexts";
import { CheckedIcon2FA } from "../../components/Icons/CheckedIcon2FA";
import { UnCheckIcon } from '../../components/Icons/UnCheckIcon'
export const TwoFactor = () => {
  const { T, user, onCheck2FA } = useApp();
  // const size = useWindowSize();

  const [checked, $checked] = useState(false)

  const handleClickChecked = (val) => {
    $checked(val);
    onCheck2FA();
  }

  return (
    <Container>
      <ContainerView background="transparent">
        <TitlePage>{T("2FA Authentication")}</TitlePage>
        <div className="flex justify-between items-start w-full container lg:gap-12 mt-[32px] min-h-[calc(100vh-740px)]">
          <div className="w-full block grow-1">
            <label
              className="flex items-center cursor-pointer gap-[12px]"
              onClick={() => handleClickChecked(!checked)}
            >
              {!!user?.is_twofa ? <CheckedIcon2FA /> : <UnCheckIcon />}

              <div className="text-black">
                {T(!!user?.is_twofa ? "Disable 2FA" : "Enable 2FA")}
              </div>
            </label>
          </div>
        </div>
      </ContainerView>
    </Container>
  );
};
